import checkJwt from './../../../Global/jwtChecker' 
import logout from './../../../Global/logout' 
import Excel from 'exceljs'
import {saveAs} from "file-saver";

export default async function AllIzvjestajToExcel(data, startDate, endDate, devices) {
    const unHashedJwt = await checkJwt()

    if(!unHashedJwt){
        logout()
    }

    const workbook = new Excel.Workbook();
    const worksheet = workbook.addWorksheet("Izvjestaj");   
    const options = {
        dateFormats: ['DD.MM.YYYY HH:mm:ss']
      };

    var dateCreated = new Date();
    dateCreated.setHours( dateCreated.getHours() + 2 );    

    var dateFrom = await new Date(startDate);; 
    dateFrom.setHours( dateFrom.getHours() + 2 );   
    var dateTo = await new Date(endDate);
    dateTo.setHours( dateTo.getHours() + 2 );   
    //dateTo= moment(dateTo).toDate()

    //const myDate = format(date,"YYYY-MM-DD").split('T')[0];//right
    //console.log(myDate)

    worksheet.mergeCells('A1', 'B1');
    worksheet.getCell('A1').font = { bold: true }
    worksheet.getCell('A1').fill = {
        type: 'pattern',
        pattern:'solid',
        fgColor:{argb:'fff2cc'}
    }
    worksheet.getCell('A1').value = 'REKAPITULACIJA PROMETA'      
    worksheet.getCell('A2').value = 'Datum od:'
    worksheet.getCell('B2').value =  dateFrom
    worksheet.getCell('A3').value = 'Datum do:'
    worksheet.getCell('B3').value = dateTo
    worksheet.getCell('D1').value = 'Kreirano:'
    worksheet.getCell('E1').value = dateCreated;
    worksheet.getCell('E1').numFmt = 'dd.mm.yyyy\\ hh:mm:ss';

    /* Now we use the keys we defined earlier to insert your data by iterating through arrData
    and calling worksheet.addRow()
    */
   let tableRowData = []
   data.forEach(function(item, index) {       
        let osnovica = 0
        let pdv = 0
        let adresa = ''
        item.taxes.forEach(function(item, tax){
            osnovica += Number(item.taxBase)
            pdv += Number(item.taxAmount)
        })

        
        devices.forEach(function(device, index) {
           if(item.businessPremisesUuid === device.uuid){
                adresa = device.address
           }
        })
        
        tableRowData.push([
            item.businessPremisesLabel,
            item.deviceIsuNumber,
            Number(item.cashAmount),
            Number(item.cardAmount),
            Number(item.theRestAmount),
            Number(item.totalAmount),
            osnovica,
            pdv,
            adresa
       ])
   })

   worksheet.addTable({
       name: 'Izvještaj',
       ref: 'A5',
       headerRow: true,
       totalsRow: true,
       style: {
         theme: 'TableStyleLight15',
         //showRowStripes: true,
       },
       columns: [
         {name: 'OZNAKA POSLOVNOG PROSTORA', totalsRowLabel: 'Ukupno:', filterButton: true },
         {name: 'ISU'},
         {name: 'GOTOVINA - G', totalsRowFunction: 'sum', filterButton: true},
         {name: 'KARTICE - K', totalsRowFunction: 'sum', filterButton: true},
         {name: 'GLOBALNI TOKEN - O', totalsRowFunction: 'sum', filterButton: true},
         {name: 'SVEUKUPNO', totalsRowFunction: 'sum', filterButton: true, font: { bold: true}},
         {name: 'OSNOVICA', totalsRowFunction: 'sum', filterButton: true},
         {name: 'PDV', totalsRowFunction: 'sum', filterButton: true},
         {name: 'ADRESA', filterButton: true}
       ],
       rows: tableRowData,
     });


     

     data.forEach(function(item, index) {
        let posProstorCell  = 'A' + (6 + index)
        let ISUCell  = 'B' + (6 + index)
        let gotovinaCell  = 'C' + (6 + index)
        let karticeCell = 'D' + (6 + index)
        let theRestAmountCell = 'E' + (6 + index)
        let totalAmountCell = 'F' + (6 + index)
        let osnovicaCell = 'G' + (6 + index)
        let PDVCell = 'H' + (6 + index)

        worksheet.getCell(posProstorCell).alignment = { vertical: 'middle', horizontal: 'center' }
        worksheet.getCell(ISUCell).alignment = { vertical: 'middle', horizontal: 'center' }
        worksheet.getCell(gotovinaCell).numFmt = '#,##0.00'
        worksheet.getCell(karticeCell).numFmt = '#,##0.00'
        worksheet.getCell(theRestAmountCell).numFmt = '#,##0.00'
        worksheet.getCell(totalAmountCell).numFmt = '#,##0.00'
        worksheet.getCell(totalAmountCell).font = { 'bold': true }
        worksheet.getCell(osnovicaCell).numFmt = '#,##0.00'
        worksheet.getCell(PDVCell).numFmt = '#,##0.00'
    })

    worksheet.getCell('C' + ( 6 + data.length)).numFmt = '#,##0.00'    
    worksheet.getCell('D' + ( 6 + data.length)).numFmt = '#,##0.00'
    worksheet.getCell('E' + ( 6 + data.length)).numFmt = '#,##0.00'
    worksheet.getCell('F' + ( 6 + data.length)).numFmt = '#,##0.00'
    worksheet.getCell('G' + ( 6 + data.length)).numFmt = '#,##0.00'
    worksheet.getCell('H' + ( 6 + data.length)).numFmt = '#,##0.00'

    // HEADER color
    worksheet.getCell('A5').fill = { type: 'pattern', pattern:'solid', fgColor:{argb:'00AFD7' }}
    worksheet.getCell('A5').font = {color: {argb: "FFFFFF"}};
    worksheet.getCell('B5').fill = { type: 'pattern', pattern:'solid', fgColor:{argb:'00AFD7' }}
    worksheet.getCell('B5').font = {color: {argb: "FFFFFF"}};
    worksheet.getCell('C5').fill = { type: 'pattern', pattern:'solid', fgColor:{argb:'00AFD7' }}
    worksheet.getCell('C5').font = {color: {argb: "FFFFFF"}};
    worksheet.getCell('D5').fill = { type: 'pattern', pattern:'solid', fgColor:{argb:'00AFD7' }}
    worksheet.getCell('D5').font = {color: {argb: "FFFFFF"}};
    worksheet.getCell('E5').fill = { type: 'pattern', pattern:'solid', fgColor:{argb:'00AFD7' }}
    worksheet.getCell('E5').font = {color: {argb: "FFFFFF"}};
    worksheet.getCell('F5').fill = { type: 'pattern', pattern:'solid', fgColor:{argb:'00AFD7' }}
    worksheet.getCell('F5').font = {color: {argb: "FFFFFF"}};
    worksheet.getCell('G5').fill = { type: 'pattern', pattern:'solid', fgColor:{argb:'00AFD7' }}
    worksheet.getCell('G5').font = {color: {argb: "FFFFFF"}};
    worksheet.getCell('H5').fill = { type: 'pattern', pattern:'solid', fgColor:{argb:'00AFD7' }}
    worksheet.getCell('H5').font = {color: {argb: "FFFFFF"}};
    worksheet.getCell('I5').fill = { type: 'pattern', pattern:'solid', fgColor:{argb:'00AFD7' }}
    worksheet.getCell('I5').font = {color: {argb: "FFFFFF"}};

    
        
    
    /*worksheet.getCell('A5').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
    worksheet.getCell('B5').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
    worksheet.getCell('C5').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
    worksheet.getCell('D5').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
    worksheet.getCell('E5').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
    worksheet.getCell('F5').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
    worksheet.getCell('G5').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
    worksheet.getCell('H5').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };*/

    const row = worksheet.getRow(5);
    row.height = 50;
    row.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }

    worksheet.columns = [
        { width: 20 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 20 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 50 }
    ];

    /*
    dobCol.header = [
        {header:'OZNAKA POSLOVNOG PROSTORA',key:'ozn'  ,width: 10}, //i need something like startRow:2
          {header:'ISU',key:'ISU'  ,width: 10},
          {header:'GOTOVINA - G',key:'got'  ,width: 10}
        ];
        
       
/*
    worksheet.columns = [
    {header: 'OZNAKA POSLOVNOG PROSTORA', key: 'ozn', width: 10},
    {header: 'ISU', key: 'ISU', width: 10}, 
    {header: 'GOTOVINA', key: 'got', width: 10,}
    ];
    
    worksheet.addRow({ozn: 1, ISU: 'John Doe', got: 0 });
    */
    // save under export.xlsx
    const buffer = await workbook.xlsx.writeBuffer(options);
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    const fileExtension = '.xlsx';
    
    const blob = new Blob([buffer], {type: fileType});

    saveAs(blob, 'Izvjestaji' + fileExtension);
}